import React from 'react';
import { cn } from '../../lib/cn';
import BeltIcon from '../ui/BeltIcon';
import type { HydratedBlogPost } from '../../types/blog';

interface PostCoverImageProps {
    post: HydratedBlogPost;
    loading?: 'lazy' | 'eager';
    className?: string;
}

const PostCoverImage: React.FC<PostCoverImageProps> = ({
    post,
    loading = 'lazy',
    className,
}) => (
    <div
        className={cn(
            'aspect-video w-full overflow-hidden relative',
            className,
        )}
    >
        {post.featured_image_url ? (
            <img
                src={post.featured_image_url}
                alt={post.title}
                loading={loading}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
        ) : (
            <div
                className="absolute inset-0 bg-gradient-to-br from-brand-primary to-brand-primary-deep flex items-center justify-center"
                aria-hidden="true"
            >
                {/* Stylised MAN belt motif — decorative; low-opacity white over the brand gradient. */}
                <BeltIcon variant="white" className="h-1/2 w-auto opacity-10" />
            </div>
        )}
    </div>
);

export default PostCoverImage;
